import { Box, FormControl, FormGroup, FormLabel } from "@material-ui/core";
import ItemSelectField from "../atoms/item_select_field";

const ItemSelectGroup = (props) => {
  const { label, items, value, onChange, ...other } = props;
  return (
    <FormGroup>
      <FormLabel>{label}</FormLabel>
      <FormControl
        variant="filled"
        component={Box}
        {...other}
        // width="100%"
        // marginBottom="1rem!important"
      >
        <Box>
          <ItemSelectField items={items} value={value} onChange={onChange} />
        </Box>
      </FormControl>
    </FormGroup>
  );
};

export default ItemSelectGroup;
